module.exports = __webpack_public_path__ + "static/media/indian-categories.b4d3e239.jpg";